module.exports = __webpack_public_path__ + "static/img/Cardfooter10.3586fa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Cardfooter10.png
// module id = VkfD
// module chunks = 1